<template>
  <span>
    <button
      class="menu-item"
      :class="{ 'is-active': isActive ? isActive(): null, 'hover': action ? true : null }"
      @click="() => action ? action(): null"
      :title="title"
    >
      <svg class="remix">
        <use :href="`${remixiconUrl}#ri-${icon}`" />
      </svg>
    </button>
  </span>
</template>

<script>
import remixiconUrl from 'remixicon/fonts/remixicon.symbol.svg'
import Vue from 'vue'
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
export default {
  props: {
    icon: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    action: {
      type: Function,
      default: null,
      required: false
    },

    isActive: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      remixiconUrl,
      test: true,
      test2: false
    }
  }
}
</script>

<style lang="scss">
.menu-item {
  background: transparent;
  border: none;
  border-radius: 0.4rem;
  color: #b6b6b6;
  margin-top: 2px;
  cursor: pointer;
  height: 1.75rem;
  padding: 0.25rem;
  margin-right: 2px;
  width: 1.55rem;

  svg {
    fill: currentColor;
    height: 100%;
    width: 100%;
  }

  &.is-active{
    color: #515051 !important;
    background-color: rgba(0,0,0,0.09) !important;
  }
}
.hover{
  &:hover{
    color: #515051;
    background-color: rgba(0, 0, 0, 0.03);

    @media (max-width: $small) {
      //background-color: transparent;
    }
  }
}
</style>
